import { ConstantUtil } from '@/utils/ConstantUtil';
import { replaceDepthNew } from '@/utils/depth';
import moment from 'moment';
import BigNumber from 'bignumber.js';

const deepcopy = require('deepcopy');

export function sendWebSocketObj(self, methodName, params) {
    if (self.webSocketIsConnected) {
        self.$socket.sendObj({
            id: ConstantUtil.webSocket[methodName].code,
            method: ConstantUtil.webSocket[methodName].name,
            params,
        });
    } else {
        setTimeout(sendWebSocketObj, 1000, self, methodName, params);
    }
}

export function dealsSubscribeHandler(self, data) {
    const id = data[0];
    if (id != self.selectedMarketId) {
        return;
    }
    let allTradeInfo = deepcopy(data[1]);
    allTradeInfo = allTradeInfo.map((v) => {
        const trade = v;
        trade.time = moment(parseInt(v.time, 10) * 1000).format('HH:mm:ss');
        return trade;
    });
    if (self.marketTrades.length) {
        self.marketTrades = [...allTradeInfo, ...self.marketTrades];
    } else {
        self.marketTrades = allTradeInfo;
    }
    if (self.marketTrades.length > 0) {
        self.lastPrice1 = self.marketTrades[0].price;
    }
    if (self.marketTrades.length > 1) {
        self.lastPrice2 = self.marketTrades[1].price;
    }
    const bigPrice1 = new BigNumber(self.lastPrice1);
    const rate = new BigNumber(self.tUSDPrice);
    const currPrice = bigPrice1.times(rate);
    self.currPrice = currPrice.toString();
}
export function depthSubcribeHandler(self, data) {
    const nowObj = { asks: self.asks, bids: self.bids };

    const depthObj = replaceDepthNew(nowObj, data[1], data[0]);
    if (data[1].asks) {
        const askData = self.calculateDepth(depthObj.asks);
        self.asks = askData;
    }
    if (data[1].bids) {
        const bidData = self.calculateDepth(depthObj.bids);
        self.bids = bidData;
    }
    self.changeDepthAcgtion();
    if (!self.initMarketStatus && data[0]) {
        if (self.asks.length > 0 && self.selectedTab != 'marketOrder') {
            self.buyPriceValue = self.asks[self.asks.length - 1].price;
        }
        if (self.bids.length > 0 && self.selectedTab != 'marketOrder') {
            self.sellPriceValue = self.bids[0].price;
        }
        self.initMarketStatus = true;
    }
}



// WEBPACK FOOTER //
// ./src/utils/websocket.js